export default function TestimonialSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-6 md:px-10 max-w-6xl mx-auto">
        <div className="relative bg-foreground-950 rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            <div className="lg:w-2/5 relative">
              <div className="absolute -left-6 top-1/2 -translate-y-1/2 w-48 h-48 lg:w-56 lg:h-56 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20lifestyle%20photography%20of%20hands%20opening%20a%20stylish%20shipping%20package%20with%20tissue%20paper%20on%20dark%20wooden%20table%2C%20soft%20natural%20daylight%2C%20unboxing%20moment%2C%20editorial%20aesthetic%2C%20warm%20tones%2C%20no%20visible%20face%2C%20no%20text%2C%20high%20detail&width=600&height=800&seq=testimonial-jun27-v2&orientation=portrait"
                  alt="ItaobuySpreadsheet user unboxing experience"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div className="lg:w-3/5 py-12 md:py-16 px-8 md:px-12 lg:pl-4">
              <i className="ri-double-quotes-l text-4xl md:text-5xl text-secondary-400"></i>
              <blockquote className="mt-4 text-lg md:text-xl text-background-50 leading-relaxed font-heading italic">
                "The itaobuyspreadsheet system completely changed how I shop from China. Instead of spending hours searching, I now browse curated lists, compare prices instantly, and order through verified agents. It has saved me both time and money on every single haul."
              </blockquote>
              <div className="mt-6">
                <p className="text-sm font-semibold text-background-50">Marcus J.</p>
                <p className="text-xs text-secondary-400 mt-0.5">Verified Buyer — United States</p>
              </div>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 mt-8 bg-secondary-500 hover:bg-secondary-400 text-background-50 font-semibold px-6 py-3 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Join 10,000+ Buyers
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}